import montantTools from "./montantTools";

// Montants et taux d'une loi de roulage saisis dans des champs texte.
const CHAMPS_MONTANT = [
  "financeRate",
  "firstRentInput",
  "applicationFee",
  "marginTTC",
  "marginTTCRate",
  "replacementVehicleCost",
  "insuranceHT",
  "insuranceFinLoss",
  "rateVR",
  "repurchaseValueFinal",
  "kmPrice",
  "rateMaintenance",
  "discountMaintenance",
  "maintenanceValueFinal",
  "franchiseDommage",
  "customTirePrice",
];

// Facultatifs : vidés, ils valent 0 dans le loyer et dans l'envoi à l'API.
const OPTIONS = [
  { champ: "insuranceHT", libelle: "Prévoyance" },
  { champ: "insuranceFinLoss", libelle: "Sérénité" },
  { champ: "replacementVehicleCost", libelle: "Véhicule relais" },
];
const CHAMPS_VIDE_VAUT_ZERO = [
  ...OPTIONS.map((o) => o.champ),
  "firstRentInput",
];

const normaliserSaisieChamp = (champ, valeur) =>
  CHAMPS_MONTANT.includes(champ)
    ? montantTools.normaliserSaisieMontant(valeur)
    : valeur;

// L'API (cast Price) répond 500 sur une chaîne vide ou à virgule.
const normaliserLignePourAPI = (ligne) => {
  const resultat = { ...ligne };
  CHAMPS_MONTANT.forEach((champ) => {
    if (champ in resultat) {
      resultat[champ] = montantTools.normaliserSaisieMontant(resultat[champ]);
    }
  });
  CHAMPS_VIDE_VAUT_ZERO.forEach((champ) => {
    if (champ in resultat && montantTools.estVide(resultat[champ])) {
      resultat[champ] = 0;
    }
  });
  return resultat;
};

const ligneDevisTools = {
  OPTIONS,
  normaliserSaisieChamp,
  normaliserLignePourAPI,
};

export default ligneDevisTools;
